module.exports = new __parcel__URL__("Nini_Chachkhalia.0fece64a.jpg").toString();